export const PERSPECTIVE_TRANSFORM_LENGTH = 16;
export const perspectiveTransformProblem = (value) => {
    if (!Array.isArray(value)) {
        return `A perspective transform needs exactly ${PERSPECTIVE_TRANSFORM_LENGTH} numbers.`;
    }
    if (value.length !== PERSPECTIVE_TRANSFORM_LENGTH ||
        value.some(entry => typeof entry !== 'number' || !Number.isFinite(entry))) {
        return (`A perspective transform needs exactly ${PERSPECTIVE_TRANSFORM_LENGTH} ` +
            `numbers — this one has ${value.length}.`);
    }
    return null;
};
//# sourceMappingURL=perspectiveTransform.validation.js.map